import { Customer } from './customer.model';
import { User } from './user.model';
import { Vehicle } from './vehicle.model';
import { WorkOrder } from './work-order.model';
import { Inspection } from './inspection.model';
import { Quote } from './quote.model';
import { AppointmentSelectedAddOn } from './appointment-add-on.model';
import { AppointmentLockDto } from './appointment-lock.model';
import { Contact } from './contact';

export interface Appointment {
    id: string | null;
    tenantId: string;
    branchId: string;
    customerId: string;
    customer: Customer;
    customerPrimaryContact?: Contact;
    contacts?: Contact[];
    vehicleId: string;
    vehicle?: Vehicle;
    scheduledDateTime: string;
    serviceDescription?: string;
    isCheckedIn: boolean;
    checkedInDateTime?: string;
    checkedInByUserId?: string;
    checkedInBy?: User;
    advisorId?: string;
    advisor?: User;
    status: AppointmentStatus;
    notes?: string;
    pickupTime?: string;
    signatureImageUrl?: string;
    /** True when the advisor signed in place of a customer who was not present, so the signature is the advisor's. */
    signedOnBehalfOfCustomer?: boolean;
    prepaidAmount?: number;
    preferredContactMethod?: PreferredContactMethod;
    accountTypeId?: string;
    accountType?: AccountType;
    workOrderId?: string;
    workOrder?: WorkOrder;
    quoteId?: string;
    quote?: Quote;
    inspectionId?: string;
    inspection?: Inspection;
    selectedAddOns?: AppointmentSelectedAddOn[];
    lock?: AppointmentLockDto;
    /**
     * The opaque pickup option value the customer chose at check-in (the PickupOption.value of the
     * selected option). Raptor does not interpret it; federations own its translation.
     */
    pickupIntent?: string;
}

export enum AppointmentStatus {
    Scheduled = 'Scheduled',
    CheckedIn = 'CheckedIn',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
}

export enum PreferredContactMethod {
    SMS = 'sms',
    Email = 'email',
    Both = 'both',
}

export interface AccountType {
    id: string;
    tenantId: string;
    name: string;
    description?: string;
    isActive: boolean;
    createdDateTime?: string;
    modifiedDateTime?: string;
}
